import { observable } from 'mobx';

export const STATUS = {
  LOADING: 'LOADING',
  FOUND: 'FOUND',
  NOT_FOUND: 'NOT_FOUND',
  ERROR_UNAUTHORIZED: 'ERROR_UNAUTHORIZED',
  ERROR_OTHER: 'ERROR_OTHER',
};

export const status = observable.box(STATUS.LOADING);



// WEBPACK FOOTER //
// ./src/store/status.js